import React from "react";
import { Search } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function EmptyState({ title = "No results found", description = "Try adjusting your filters or search query.", actionLabel, onAction }) {
  return (
    <div data-testid="empty-state" className="text-center py-16 px-4">
      <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-[#F5EFE6] mb-4">
        <Search size={22} className="text-[#1F4E3D]" strokeWidth={1.75} />
      </div>
      <h3 className="font-heading text-xl text-[#111827] mb-2">{title}</h3>
      <p className="text-sm text-[#4B5563] max-w-sm mx-auto">{description}</p>
      {actionLabel && onAction && (
        <Button onClick={onAction} variant="outline" className="mt-4" data-testid="empty-state-action">
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
